const KeyIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={30} height={30} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>Key Icon</title>
    <mask
      id="a"
      style={{
        maskType: 'alpha',
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={30}
      height={30}
    >
      <rect width={30} height={30} rx={15} fill="#305DFE" />
    </mask>
    <g mask="url(#a)">
      <path
        d="M8.75 18.029a2.92 2.92 0 0 0 2.145-.884A2.92 2.92 0 0 0 11.778 15a2.92 2.92 0 0 0-.883-2.145 2.92 2.92 0 0 0-2.145-.884 2.92 2.92 0 0 0-2.146.884A2.92 2.92 0 0 0 5.721 15c0 .841.294 1.556.883 2.145a2.92 2.92 0 0 0 2.146.884Zm0 3.678c-1.875 0-3.462-.65-4.76-1.947-1.298-1.298-1.947-2.885-1.947-4.76s.649-3.461 1.947-4.76c1.298-1.298 2.885-1.947 4.76-1.947 1.55 0 2.9.44 4.049 1.318 1.899 1.452 3.942 3.201 6.332 3.201h5.942a2.249 2.249 0 0 1 1.67 3.755L25.64 17.79a1.94 1.94 0 0 1-2.629.234l-.055-.043a1.856 1.856 0 0 0-2.378.087 1.856 1.856 0 0 1-2.48.001l-.473-.424a1.789 1.789 0 0 0-1.195-.457c-.782 0-1.45.524-1.835 1.205-.442.782-1.057 1.46-1.844 2.035-1.168.852-2.502 1.279-4.001 1.279Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export default KeyIcon;
